import { render, staticRenderFns } from "./custom-product.vue?vue&type=template&id=40073be6&scoped=true&"
import script from "./custom-product.vue?vue&type=script&lang=js&"
export * from "./custom-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40073be6",
  null
  
)

export default component.exports